import * as yup from 'yup'

const ChangeEmailSchema = yup.object().shape({
  email: yup.string()
    .email('common.errors.email.invalid')
})

export { ChangeEmailSchema }
